import type { TFunction } from 'i18next';

import { GridRecord } from '../../components/Grid/GridDataTypes';
import { DefaultApi, GetOneToolTeamDto } from '../autogenerated/pokApiClient';
import { TKeys } from '../../hooks/useTranslation';
import { oneToolTeamForGrid } from '../../../pok/components/OneToolTeams/OneToolTeamSearch';

export interface OneToolTeamContextInterface {
  findAllActive: () => Promise<GetOneToolTeamDto[]>;
  getById: (id: string) => Promise<GetOneToolTeamDto>;
  sync: () => Promise<void>;
  getAllByPortion: (
    t: TFunction<'administrationLng', 'administrationLng'>,
    tk: TKeys<'administrationLng'>,
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
}

export const OneToolTeamContext = (
  api: DefaultApi,
): OneToolTeamContextInterface => ({
  findAllActive: () => api.oneToolTeamControllerFindAllActive(),
  getById: (id: string) => api.oneToolTeamControllerGetById(id),
  sync: () => api.oneToolTeamControllerSync(),
  getAllByPortion: async (
    t,
    tk,
    pageSize,
    pageNumber,
    orderBy,
    orderDirection,
    filterText,
    filterColumns,
  ) => {
    const data = await api.oneToolTeamControllerGetAllByPortion(
      pageSize,
      pageNumber,
      orderBy || '',
      orderDirection || '',
      filterText || '',
      filterColumns,
    );
    return data.map(team => oneToolTeamForGrid(t, tk, team));
  },
  getAllCount: (filterText?: string, filterColumns?: string) =>
    api.oneToolTeamControllerGetAllCount(filterText || '', filterColumns),
});
